import {INIT_SETTINGS, START_AJAX_REQUEST, END_AJAX_REQUEST} from '../constants/settings-constants';

export function initSettings(data) {
    return {
        type: INIT_SETTINGS,
        data
    }
}



// WEBPACK FOOTER //
// ./src/_app/drafts/actions/settings_actions.js